import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { HelpIcon } from '@shared/assets/icons';
import { i18TranslationNS, Translation } from '@shared/config/i18n';
import { useBrandTheme } from '@shared/lib/brandTheme';
import { TabButton } from '@shared/ui/tabButton';

import s from './HeaderSupport.module.css';

export const HeaderSupport = () => {
	const { t } = useTranslation(i18TranslationNS);
	const { helpFaqUrl } = useBrandTheme();

	const labels = {
		helpFaq: t(Translation.HEADER_NAV_HELP_FAQ),
	};
	const handleOpenHelp = () => {
		if (!helpFaqUrl) return;
		window.open(helpFaqUrl, '_blank', 'noopener,noreferrer');
	};

	return (
		<TabButton
			label={labels.helpFaq}
			leftIcon={HelpIcon}
			disabled={!helpFaqUrl}
			className={clsx(
				'button-tertiary',
				'button-tertiary--default',
				'button-tertiary--icon-trailing',
				s.header_support,
			)}
			labelClassName='semantic-button-secondary-sm'
			iconClassName='button-tertiary__icon'
			onClick={handleOpenHelp}
		/>
	);
};
